import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "student-challenge-page" }
const _hoisted_2 = { class: "filter-item" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = { class: "filter-item" }
const _hoisted_6 = { class: "action-area" }
const _hoisted_7 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_8 = {
  key: 1,
  class: "result-section"
}
const _hoisted_9 = { class: "result-badge" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "result-content" }
const _hoisted_13 = { class: "result-title" }
const _hoisted_14 = { class: "score-diff" }
const _hoisted_15 = { class: "analysis-item advantage" }
const _hoisted_16 = { class: "subject-tags" }
const _hoisted_17 = {
  key: 0,
  class: "no-subject"
}
const _hoisted_18 = { class: "analysis-item disadvantage" }
const _hoisted_19 = { class: "subject-tags" }
const _hoisted_20 = {
  key: 0,
  class: "no-subject"
}
const _hoisted_21 = {
  key: 2,
  class: "comparison-results"
}
const _hoisted_22 = {
  key: 3,
  class: "empty-state"
}

import { ref, onMounted, computed } from 'vue';
import { message } from 'ant-design-vue';
import { useUserStore } from '@/store';
import { getClassesApi } from '@/servers/api/classes';
import { getClassExam } from '@/servers/api/grade';
import { getStudentApi } from '@/servers/api/student';
import { getCompareWithStudent } from '@/servers/api/analysis';

// 状态管理

export default /*@__PURE__*/_defineComponent({
  __name: 'StudentChallengePage',
  setup(__props) {

const userStore = useUserStore();
const userInfo = userStore.userInfo;

// 核心状态
const loading = ref(false);
const showComparisonTables = ref(false);
const hasSearched = ref(false); // 标记是否执行过对比

// 班级相关（不可改）
const classList = ref<any[]>([]);
const selectedClassId = ref<number | undefined>(userInfo?.student?.class_id);

// 考试相关
const examList = ref<any[]>([]);
const selectedExamId = ref<number>(0);

// 对手相关
const opponentClassList = ref<any[]>([]);
const opponentClassId = ref<number | undefined>();
const opponentStudents = ref<any[]>([]); // 对手班级学生列表
const filteredOpponentStudents = ref<any[]>([]); // 搜索过滤后的学生列表
const finalOpponentId = ref<string | undefined>(); // 最终使用的对手ID（选择/输入一体化）
const finalOpponentName = ref<string>('未知对手'); // 最终显示的对手姓名
const opponentNameInput = ref<string>(''); // 对手姓名输入框

// 对比数据
const currentStudentData = ref<any>({});
const compareStudentData = ref<any>({});
const scoreComparisonData = ref<any[]>([]); // 分数对比数据
const rankComparisonData = ref<any[]>([]); // 段次对比数据

// 学科名称映射（所有科目，中文）
const allSubjectMap: Record<string, string> = {
  '语文': '语文',
  '数学': '数学',
  '英语': '英语',
  '物理': '物理',
  '化学': '化学',
  '生物': '生物',
  '历史': '历史',
  '政治': '政治',
  '地理': '地理',
  '总分': '总分'
};

// 根据学生选科过滤的科目映射
const subjectMap = computed(() => {
  const filteredMap: Record<string, string> = {
    '语文': '语文',
    '数学': '数学',
    '英语': '英语',
    '总分': '总分'
  };

  const selectedSubjects = userInfo?.student?.subject_selection;
  if (!selectedSubjects) {
    // 如果没有选科信息，显示所有科目
    return allSubjectMap;
  }

  // 根据选科信息过滤科目
  if (selectedSubjects.indexOf('物') !== -1) filteredMap['物理'] = '物理';
  if (selectedSubjects.indexOf('化') !== -1) filteredMap['化学'] = '化学';
  if (selectedSubjects.indexOf('生') !== -1) filteredMap['生物'] = '生物';
  if (selectedSubjects.indexOf('史') !== -1) filteredMap['历史'] = '历史';
  if (selectedSubjects.indexOf('政') !== -1) filteredMap['政治'] = '政治';
  if (selectedSubjects.indexOf('地') !== -1) filteredMap['地理'] = '地理';

  return filteredMap;
});

// 解析年级
const getCurrentGrade = () => {
  if (selectedClassId.value) {
    const classIdStr = selectedClassId.value.toString();
    return classIdStr.slice(0, 2);
  }
  return '';
};

const examTime = (exam: any) => {
  const timeText = exam.update_time || exam.create_time || '';
  const time = timeText ? new Date(timeText).getTime() : 0;
  return Number.isFinite(time) ? time : 0;
};

// 初始化：获取班级、考试列表
const init = async () => {
  try {
    loading.value = true;
    // 1. 获取当前学生班级列表（默认选中当前班级，不可改）
    const classRes = await getClassesApi({ header: userInfo?.teacher?.uid });
    if (classRes.code === 200 && classRes.data.length > 0) {
      classList.value = classRes.data;
      // 若未自动选中，默认选第一个
      if (!selectedClassId.value && classList.value.length > 0) {
        selectedClassId.value = classList.value[0].id;
      }
    }

    // 2. 获取考试列表（默认选中最新考试）
    const examRes = await getClassExam({ class_id: selectedClassId.value });
    if (examRes.code === 200 && examRes.data.length > 0) {
      // 直接使用返回的考试对象数组（包含id和name）
      examList.value = examRes.data.map((exam: any) => ({
        id: exam.id,
        name: exam.name,
        create_time: exam.create_time,
        update_time: exam.update_time
      })).sort((a: any, b: any) => {
        const timeDiff = examTime(b) - examTime(a);
        return timeDiff || Number(b.id) - Number(a.id);
      });
      
      if (examList.value.length > 0) {
        selectedExamId.value = examList.value[0].id;
      }
    }

    // 3. 获取对手班级列表（排除当前班级）
    const allClassesRes = await getClassesApi({ school_id: userInfo?.student?.school_id });
    if (allClassesRes.code === 200) {
      const currentGrade = getCurrentGrade();
      opponentClassList.value = allClassesRes.data
        .filter((cls: any) => cls.id !== selectedClassId.value)
        .filter((cls: any) => {
          const classIdStr = cls.id.toString();
          const classGrade = classIdStr.slice(0, 2);
          return classGrade === currentGrade;
        });
    }
  } catch (err) {
    message.error('初始化数据失败');
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// 获取对手班级的学生列表
const fetchOpponentStudents = async () => {
  if (!opponentClassId.value) {
    opponentStudents.value = [];
    filteredOpponentStudents.value = [];
    finalOpponentName.value = '未知对手';
    return;
  }
  try {
    loading.value = true;
    const studentRes = await getStudentApi({ class_id: opponentClassId.value });
    if (studentRes.code === 200 && studentRes.data) {
      opponentStudents.value = studentRes.data.map((item: any) => ({
        id: item.uid,
        name: item.name,
        uid: item.uid,
        class_id: item.class_id
      }));
      filteredOpponentStudents.value = [...opponentStudents.value]; // 初始化过滤列表
    } else {
      message.warning(studentRes.msg || '获取对手学生列表失败');
      opponentStudents.value = [];
      filteredOpponentStudents.value = [];
      finalOpponentName.value = '未知对手';
    }
  } catch (err) {
    message.error('获取对手学生列表失败');
    console.error(err);
    finalOpponentName.value = '未知对手';
  } finally {
    loading.value = false;
  }
};

// 对手姓名搜索过滤
const handleOpponentSearch = (value: string) => {
  if (!value) {
    filteredOpponentStudents.value = [...opponentStudents.value];
    return;
  }
  const lowerValue = value.toLowerCase();
  filteredOpponentStudents.value = opponentStudents.value.filter((student: any) => 
    student.name.toLowerCase().includes(lowerValue) || 
    student.uid.toLowerCase().includes(lowerValue)
  );
};

const handleOpponentSelect = (studentId: string | undefined) => {
  if (studentId) {
    const selectedStudent = opponentStudents.value.find((s: any) => s.id === studentId);
    if (selectedStudent) {
      finalOpponentId.value = studentId;
      finalOpponentName.value = selectedStudent.name;
    }
  } else {
    finalOpponentId.value = undefined;
    finalOpponentName.value = '未知对手';
  }
};

// 手动输入对手姓名
const handleManualInput = (value: string) => {
  if (value) {
    finalOpponentName.value = value;
    const matchedStudent = opponentStudents.value.find(
      (s: any) => s.name.toLowerCase() === value.toLowerCase()
    );
    finalOpponentId.value = matchedStudent?.id || value;
  } else {
    finalOpponentId.value = undefined;
    finalOpponentName.value = '未知对手';
  }
};

// 处理对手姓名输入变化
const handleOpponentNameChange = () => {
  const value = opponentNameInput.value?.trim();
  if (value) {
    finalOpponentName.value = value;
    // 先尝试从已加载的学生列表中匹配
    const matchedStudent = opponentStudents.value.find(
      (s: any) => s.name === value
    );
    finalOpponentId.value = matchedStudent?.id || value;
  } else {
    finalOpponentId.value = undefined;
    finalOpponentName.value = '未知对手';
  }
};

// 计算总分差值
const totalScoreDiff = computed(() => {
  const currentTotal = getScoreValue(currentStudentData.value, '总分');
  const opponentTotal = getScoreValue(compareStudentData.value, '总分');
  return currentTotal - opponentTotal;
});

// 获取优势科目（本人分数 > 对手）
const getAdvantageSubjects = () => {
  return scoreComparisonData.value
    .filter(item => item.subject !== '总分' && Number(item.diff) > 0)
    .map(item => item.subject);
};

// 获取劣势科目
const getDisadvantageSubjects = () => {
  return scoreComparisonData.value
    .filter(item => item.subject !== '总分' && Number(item.diff) < 0)
    .map(item => item.subject);
};

// 执行对比（同时获取分数和段次数据）
const runComparison = async () => {
  if (!selectedExamId.value || !finalOpponentId.value || !userInfo?.student?.uid) {
    message.warning('请选择完整的对比条件（考试+对手班级+对手）');
    return;
  }

  try {
    loading.value = true;
    hasSearched.value = true;
    showComparisonTables.value = false;

    const res = await getCompareWithStudent({
      student_id: userInfo.student.uid,
      compare_student_id: finalOpponentId.value,
      selected_exam_id: selectedExamId.value,
      compare_class_id: opponentClassId.value
    } as any);

    if (res.code === 200 && res.data) {
      currentStudentData.value = res.data.current_student;
      compareStudentData.value = res.data.compare_student;
      
      // 格式化分数对比数据（只显示选科的科目）
      scoreComparisonData.value = Object.entries(subjectMap.value).map(([en, cn]) => {
        const currentVal = getScoreValue(currentStudentData.value, en);
        const compareVal = getScoreValue(compareStudentData.value, en);
        return {
          subject: cn,
          current: currentVal,
          opponent: compareVal,
          diff: (currentVal - compareVal).toFixed(2)
        };
      });

      // 格式化段次对比数据（只显示选科的科目）
      rankComparisonData.value = Object.entries(subjectMap.value).map(([en, cn]) => {
      const currentClassRank = getClassRankValue(currentStudentData.value, en);
      const compareClassRank = getClassRankValue(compareStudentData.value, en);
      const currentGradeRank = getGradeRankValue(currentStudentData.value, en);
      const compareGradeRank = getGradeRankValue(compareStudentData.value, en);

      const classDiffRaw = currentClassRank - compareClassRank; 
      const gradeDiffRaw = currentGradeRank - compareGradeRank;

      return {
        subject: cn,
        currentClass: currentClassRank,
        opponentClass: compareClassRank,
        currentGrade: currentGradeRank,
        opponentGrade: compareGradeRank,
        classDiff: Math.abs(classDiffRaw), 
        gradeDiff: Math.abs(gradeDiffRaw),
        classDiffRaw,
        gradeDiffRaw,
      };
    });

      showComparisonTables.value = true;
    } else {
      message.error(res?.msg || '获取对比数据失败');
    }
  } catch (err) {
    message.error('获取对比数据失败');
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// 获取分数值
const getScoreValue = (data: any, subject: string) => {
  return data[subject] || 0;
};

// 获取班级段次值
const getClassRankValue = (data: any, subject: string) => {
  return data[`${subject}班次`] || 0;
};

// 获取年级段次值
const getGradeRankValue = (data: any, subject: string) => {
  return data[`${subject}段次`] || 0;
};

// 分数差值样式（正数优于对手，绿色；负数红色）
const getScoreDiffClass = (diff: string) => {
  const diffNum = Number(diff);
  return diffNum > 0 ? 'positive' : diffNum < 0 ? 'negative' : 'zero';
};

// 段次差值样式
const getRankDiffClass = (diffRaw: number) => {
  if (diffRaw < 0) {
    // 本人名次 - 对手名次 < 0 → 绿色
    return 'positive';
  } else if (diffRaw > 0) {
    // 本人名次 - 对手名次 > 0 → 红色
    return 'negative';
  } else {
    // 并列 → 黑色
    return 'zero';
  }
};
// 对比按钮禁用状态
const isCompareBtnDisabled = computed(() => {
  return (
    loading.value || 
    !selectedClassId.value || 
    !selectedExamId.value || 
    !opponentClassId.value || 
    !finalOpponentId.value
  );
});

// 分数表格列定义
const scoreColumns = computed(() => [
  { title: '学科', dataIndex: 'subject', key: 'subject', width: 100 },
  { 
    title: `${userInfo?.student?.name || '本人'}`, 
    dataIndex: 'current', 
    key: 'current',
    width: 120,
    customRender: ({ value }: { value: any }) => value.toFixed(2)
  },
  { 
    title: `${finalOpponentName.value}`, 
    dataIndex: 'opponent', 
    key: 'opponent',
    width: 120,
    customRender: ({ value }: { value: any }) => value.toFixed(2)
  },
  { title: '分差（本人-对手）', dataIndex: 'diff', key: 'diff', width: 140 }
]);

// 段次表格列定义
const rankColumns = computed(() => [
  { title: '学科', dataIndex: 'subject', key: 'subject', width: 100 },
  // 班级段次
  { 
    title: `${userInfo?.student?.name || '本人'}（班级名次）`, 
    dataIndex: 'currentClass', 
    key: 'currentClass',
    width: 120,
    customRender: ({ value }: { value: any }) => value || '0'
  },
  { 
    title: `${finalOpponentName.value}（班级名次）`, 
    dataIndex: 'opponentClass', 
    key: 'opponentClass',
    width: 120,
    customRender: ({ value }: { value: any }) => value || '0'
  },
  { 
    title: '班级名次差', 
    dataIndex: 'classDiff', 
    key: 'classDiff', 
    width: 140,
  },
  // 年级段次
  { 
    title: `${userInfo?.student?.name || '本人'}（年级名次）`, 
    dataIndex: 'currentGrade', 
    key: 'currentGrade',
    width: 120,
    customRender: ({ value }: { value: any }) => value || '0'
  },
  { 
    title: `${finalOpponentName.value}（年级名次）`, 
    dataIndex: 'opponentGrade', 
    key: 'opponentGrade',
    width: 120,
    customRender: ({ value }: { value: any }) => value || '0'
  },
  { 
    title: '年级名次差', 
    dataIndex: 'gradeDiff', 
    key: 'gradeDiff', 
    width: 140,
  }
]);

// 页面加载时初始化数据
onMounted(init);

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, {
      bordered: false,
      class: "header-card"
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "header-content" }, [
          _createElementVNode("h2", null, "学生挑战"),
          _createElementVNode("p", null, "选择考试和对手，进行学科维度对比分析")
        ], -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      bordered: false,
      class: "filter-card"
    }, {
      title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createElementVNode("span", { class: "card-title" }, "筛选条件", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: [24, 24] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 24,
              md: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "所属班级：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedClassId.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedClassId).value = $event)),
                    placeholder: "选择班级",
                    style: {"width":"100%"},
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classList.value, (cls) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cls.id,
                          value: cls.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cls.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 24,
              md: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "选择考试：", -1)),
                  _createVNode(_component_a_select, {
                    value: selectedExamId.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((selectedExamId).value = $event)),
                    placeholder: "选择考试",
                    style: {"width":"100%"},
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examList.value, (exam) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: exam.id,
                          value: exam.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(exam.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_divider, { dashed: "" }),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "filter-subtitle" }, "选择对手", -1)),
        _createVNode(_component_a_row, { gutter: [24, 24] }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              span: 24,
              md: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "对手班级：", -1)),
                  _createVNode(_component_a_select, {
                    value: opponentClassId.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((opponentClassId).value = $event)),
                    placeholder: "选择对手班级",
                    style: {"width":"100%"},
                    disabled: loading.value,
                    onChange: fetchOpponentStudents
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opponentClassList.value, (cls) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: cls.id,
                          value: cls.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cls.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, {
              span: 24,
              md: 12
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "对手姓名：", -1)),
                  _createVNode(_component_a_input, {
                    value: opponentNameInput.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((opponentNameInput).value = $event)),
                    placeholder: "请输入对手姓名",
                    style: {"width":"100%"},
                    disabled: loading.value,
                    "allow-clear": "",
                    onChange: handleOpponentNameChange
                  }, null, 8, ["value", "disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: runComparison,
            disabled: isCompareBtnDisabled.value,
            loading: loading.value,
            class: "compare-button"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode(" 开始挑战 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "tip-section" }, " 说明：默认选择最近一次考试，输入对手姓名后点击\"开始挑战\"进行学科维度比较。 ", -1))
      ]),
      _: 1
    }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_a_spin, {
            size: "large",
            tip: "加载中..."
          })
        ]))
      : _createCommentVNode("", true),
    (!loading.value && showComparisonTables.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_a_card, {
            bordered: false,
            class: "result-card"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["challenge-result-header", totalScoreDiff.value >= 0 ? 'success' : 'error'])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (totalScoreDiff.value >= 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "✔"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "✖"))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h3", _hoisted_13, _toDisplayString(_unref(userInfo)?.student?.name || '本人') + " 挑战" + _toDisplayString(totalScoreDiff.value >= 0 ? '成功' : '失败'), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "diff-label" }, "总分差距：", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["diff-value", totalScoreDiff.value >= 0 ? 'positive' : 'negative'])
                    }, _toDisplayString(totalScoreDiff.value >= 0 ? '+' : '') + _toDisplayString(totalScoreDiff.value.toFixed(1)), 3)
                  ])
                ])
              ], 2),
              _createVNode(_component_a_row, {
                gutter: 24,
                class: "analysis-row"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "analysis-label" }, "优势科目：", -1)),
                        _createElementVNode("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAdvantageSubjects(), (sub, idx) => {
                            return (_openBlock(), _createBlock(_component_a_tag, {
                              key: idx,
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(sub), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          (getAdvantageSubjects().length === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "暂无"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    md: 12
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "analysis-label" }, "劣势科目：", -1)),
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDisadvantageSubjects(), (sub, idx) => {
                            return (_openBlock(), _createBlock(_component_a_tag, {
                              key: idx,
                              color: "error"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(sub), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          (getDisadvantageSubjects().length === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "暂无"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!loading.value && showComparisonTables.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_a_card, {
            bordered: false,
            class: "table-card",
            title: "分数对比"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                "data-source": scoreComparisonData.value,
                bordered: "",
                columns: scoreColumns.value,
                pagination: false,
                size: "middle"
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.dataIndex === 'diff')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["diff-text", getScoreDiffClass(record.diff)])
                      }, _toDisplayString(Math.abs(parseFloat(record.diff))) + _toDisplayString(record.diff > 0 ? '↑' : '↓'), 3))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "columns"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, {
            bordered: false,
            class: "table-card",
            title: "段次对比"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                "data-source": rankComparisonData.value,
                bordered: "",
                columns: rankColumns.value,
                pagination: false,
                size: "middle"
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.dataIndex === 'classDiff')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["diff-text", getRankDiffClass(record.classDiffRaw)])
                      }, _toDisplayString(record.classDiff) + _toDisplayString(record.classDiff > 0 ? '↑' : '↓'), 3))
                    : (column.dataIndex === 'gradeDiff')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["diff-text", getRankDiffClass(record.gradeDiffRaw)])
                        }, _toDisplayString(record.gradeDiff) + _toDisplayString(record.gradeDiff > 0 ? '↑' : '↓'), 3))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "columns"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !showComparisonTables.value && hasSearched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(_component_a_empty, { description: "未找到对比数据，请检查选择条件或对手信息是否正确" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})